export default __webpack_public_path__ + "static/media/saving-bank.47a29b2e.svg";